const capitalizeFirstLetter = (str: string): string =>
    str.charAt(0).toUpperCase() + str.slice(1);

const capitalizeNames = (str: string): string =>
    str
        .split(' ') // Divide la cadena en un arreglo de palabras
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitaliza la primera letra de cada palabra
        .join(' '); // Vuelve a unir las palabras en una sola cadena

export const formatStrings = {
    capitalizeFirstLetter,
    capitalizeNames,
};
